<template>
  <app-client-layout title="プロフィール変更">
    <template #header>
      <h2
        class="flex justify-between text-xl font-semibold leading-tight text-gray-800">
        プロフィール変更
      </h2>
    </template>
    <div class="mx-auto max-w-7xl bg-white m-4 p-8 sm:px-6 lg:px-8">
      <p
        v-if="displayUpdateDoneMessage"
        class="text-red-400 text-xl font-bold text-right">
        {{ displayUpdateDoneMessage }}
      </p>
      <div
        v-if="isError"
        class="flex">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 text-red-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <div class="ml-2 text-red-500">必須項目を全て入力してください</div>
      </div>
      <div class="col-span-9">
        <div
          class="grid grid-cols-4 text-sm md:text-base text-black py-2 items-center">
          <p>名前<span class="text-red-400 ml-1">* 必須</span></p>
          <input
            v-model="userInfoState.name"
            type="text"
            class="ml-2 pl-2 text-xs md:text-base col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400" />
        </div>

        <div
          class="grid grid-cols-4 text-sm md:text-base text-black py-2 items-center">
          <p>
            性別<span
              v-if="!userInfoState.isInputSchoolInfo"
              class="text-red-400 ml-1">* 必須</span>
          </p>
          <label class="mx-1 inline-flex text-xs md:text-base items-center">
            男性
            <input
              v-model="userInfoState.sex"
              value="0"
              type="radio"
              class="form-radio mx-1"
              name="sex" />
          </label>
          <label class="mx-1 inline-flex text-xs md:text-base items-center">
            女性
            <input
              v-model="userInfoState.sex"
              value="1"
              type="radio"
              class="form-radio mx-1"
              name="sex" />
          </label>
          <label class="mx-1 inline-flex text-xs md:text-base items-center">
            無回答
            <input
              v-model="userInfoState.sex"
              value="2"
              type="radio"
              class="form-radio mx-1"
              name="sex" />
          </label>
        </div>

        <div
          class="grid grid-cols-4 text-sm md:text-base text-black py-2 items-center">
          <p>
            郵便番号<span
              v-if="!userInfoState.isInputSchoolInfo"
              class="text-red-400 ml-1">* 必須</span>
          </p>
          <input
            pattern="[0-9]+"
            maxlength="7"
            :value="userInfoState.postalCode"
            type="text"
            class="ml-2 pl-2 text-xs md:text-base col-span-2 md:col-span-1 rounded border-blue-400"
            @input="userInfoState.postalCode = postalValidate($event)" />
          <button
            class="px-4 py-2 ml-2 rounded bg-blue-600 hover:bg-blue-400 text-white max-w-max shadow-sm hover:shadow-lg"
            @click="searchAddress()">
            住所検索
          </button>
        </div>

        <div
          v-if="execSearchFlag && isAddressBlank"
          class="ml-2 text-red-500">
          住所が見つかりません。
        </div>
        <div
          class="grid grid-cols-4 text-sm md:text-base text-black py-2 items-center">
          <p>
            住所<span
              v-if="!userInfoState.isInputSchoolInfo"
              class="text-red-400 ml-1">* 必須</span>
          </p>
          <input
            v-model="userInfoState.address"
            type="text"
            class="ml-2 pl-2 text-xs md:text-base col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400" />
        </div>

        <div
          class="grid grid-cols-4 text-sm md:text-base text-black py-2 items-center">
          <p>
            職業<span
              v-if="!userInfoState.isInputSchoolInfo"
              class="text-red-400 ml-1">* 必須</span>
          </p>
          <select
            v-model="userInfoState.job"
            class="ml-2 pl-2 text-xs md:text-base col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400">
            <option
              v-for="(n, i) in USER_INFO_JOBS"
              :key="i"
              :value="i + 1">
              {{ n }}
            </option>
          </select>
        </div>
        <div
          v-if="isStatusOtherJob"
          class="grid grid-cols-4 text-sm md:text-base text-black py-2 items-center rounded border-blue-400">
          <p>
            職業<br />(自由記述)<span
              v-if="!userInfoState.isInputSchoolInfo"
              class="text-red-400 ml-1">* 必須</span>
          </p>
          <input
            v-model="userInfoState.jobText"
            type="text"
            class="ml-2 pl-2 text-xs md:text-base col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400" />
        </div>
        <div
          class="grid grid-cols-4 text-sm md:text-base text-black py-2 items-center">
          <p>学年・勤続年数<span class="text-red-400 ml-1">* 必須</span></p>
          <select
            v-model="userInfoState.serviceYears"
            class="ml-2 pl-2 text-xs md:text-base col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400">
            <option
              v-for="(n, i) in USER_INFO_SERVICE_YEARS"
              :key="i"
              :value="i + 1">
              {{ n }}
            </option>
          </select>
        </div>
        <div
          v-if="isStatusOtherServiceYear"
          class="grid grid-cols-4 flex text-sm md:text-base text-black py-2 items-center rounded border-blue-400">
          <p>
            学年・勤続年数<br />(自由記述)<span
              class="text-red-400 ml-1">* 必須</span>
          </p>
          <input
            v-model="userInfoState.serviceYearsText"
            type="text"
            class="ml-2 pl-2 text-xs md:text-base col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400" />
        </div>
        <div
          class="grid grid-cols-4 text-sm md:text-base text-black py-2 items-center">
          <p>所属先</p>
          <input
            v-model="userInfoState.affiliation"
            type="text"
            class="ml-2 pl-2 text-xs md:text-base col-span-3 sm:col-span-2 md:col-span-2 rounded border-blue-400" />
        </div>

        <div v-if="userInfoState.isInputSchoolInfo">
          <div
            class="grid grid-cols-4 text-sm md:text-base text-black py-2 items-center">
            <p>学校名</p>
            <p
              class="ml-2 pl-2 py-2 min-h-[34px] md:min-h-[42px] border border-transparent text-xs md:text-base col-span-3 sm:col-span-2 md:col-span-2">
              {{ userInfoState.school }}
            </p>
          </div>

          <div
            class="grid grid-cols-4 text-sm md:text-base text-black py-2 items-center">
            <p>学部・学科</p>
            <p
              class="ml-2 pl-2 py-2 min-h-[34px] md:min-h-[42px] border border-transparent text-xs md:text-base col-span-3 sm:col-span-2 md:col-span-2">
              {{ userInfoState.department }}
            </p>
          </div>

          <div
            class="grid grid-cols-4 text-sm md:text-base text-black py-2 items-center">
            <p>入学年月</p>
            <p
              class="ml-2 pl-2 py-2 min-h-[34px] md:min-h-[42px] border border-transparent text-xs md:text-base col-span-3 sm:col-span-2 md:col-span-2">
              {{ userInfoState.dateOfAdmission }}
            </p>
          </div>

          <div
            class="grid grid-cols-4 text-sm md:text-base text-black py-2 items-center">
            <p>学籍番号</p>
            <p
              class="ml-2 pl-2 py-2 min-h-[34px] md:min-h-[42px] border border-transparent text-xs md:text-base col-span-3 sm:col-span-2 md:col-span-2">
              {{ userInfoState.studentId }}
            </p>
          </div>
        </div>

        <div class="text-right">
          <Button
            class="ml-auto disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="isBlankForm"
            @click="submit">
            プロフィール情報更新
          </Button>
        </div>
      </div>
    </div>
  </app-client-layout>
</template>

<script setup>
import { ref, reactive, computed } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-vue3'
import { Core as YubinBangoCore } from 'yubinbango-core'
import AppClientLayout from '@/Layouts/AppClientLayout'
import { USER_INFO_AREAS } from '@/Constants/areas'
import { USER_INFO_JOBS } from '@/Constants/jobs'
import { USER_INFO_SERVICE_YEARS } from '@/Constants/serviceYears'
import Button from '@/Jetstream/Button'

const isError = ref(false)
const execSearchFlag = ref(false)

const props = defineProps({
  user: {
    type: Object,
    require: true,
  },
})

const userInfoState = reactive({
  name: props.user.name,
  sex: props.user.sex,
  area: props.user.area,
  postalCode: props.user.postal_code,
  address: props.user.address,
  affiliation: props.user.affiliation,
  job: props.user.job,
  jobText: props.user.job_text,
  serviceYears: props.user.service_years,
  serviceYearsText: props.user.service_years_text,
  isInputSchoolInfo: props.user.is_input_school_info,
  school: props.user.school,
  department: props.user.department,
  schoolEmail: props.user.school_email,
  dateOfAdmission: props.user.date_of_admission,
  studentId: props.user.student_id,
})

const displayUpdateDoneMessage = computed(
  () => usePage().props.value.flash.message,
)

const isStatusOtherJob = computed(() => userInfoState.job === 13)
const isStatusOtherServiceYear = computed(
  () => userInfoState.serviceYears === 10,
)

const isBlankForm = computed(() => {
  let isBlank = false

  // 学生情報が入力される場合は基本情報を必須にしない
  if (!userInfoState.isInputSchoolInfo) {
    if (
      !userInfoState.name
      || userInfoState.sex == null
      || !userInfoState.postalCode
      || String(userInfoState.postalCode).length < 7
      || !userInfoState.address
      || !userInfoState.job
      || !userInfoState.serviceYears
    ) {
      isBlank = true
    } else if (userInfoState.job === 13 && !userInfoState.jobText) {
      isBlank = true
    } else if (
      userInfoState.serviceYears === 10
      && !userInfoState.serviceYearsText
    ) {
      isBlank = true
    }
  }

  // 学生情報が有効な場合は編集可能な氏名・学年のみ必須チェック
  if (
    userInfoState.isInputSchoolInfo
    && (!userInfoState.name || !userInfoState.serviceYears)
  ) {
    isBlank = true
  }

  return isBlank
})

const isAddressBlank = computed(() => (!userInfoState.address))

const postalValidate = (e) => {
  const re = new RegExp(e.target.pattern)
  const result = re.exec(e.target.value)
  return (e.target.value = result ? result[0] : result)
}

const searchAddress = () => {
  new YubinBango.Core(String(userInfoState.postalCode), (addr) => {
    execSearchFlag.value = true
    userInfoState.address = addr.region // 都道府県
    userInfoState.address += addr.locality // 市区町村
    userInfoState.address += addr.street // 町域
  })
}

const submit = () => {
  if (!userInfoState.isInputSchoolInfo) {
    userInfoState.school = ''
    userInfoState.department = ''
    userInfoState.studentId = ''
    userInfoState.dateOfAdmission = ''
  }

  Inertia.visit(route('client.profile.update'), {
    method: 'post',
    data: {
      userInfoState,
    },
  })
}
</script>
